import jwtDecode from "jwt-decode";
export const isJwtExpired = (jwt) => {
    if (!jwt)
        return true;
    try {
        const parsed = jwtDecode(jwt);
        if (!parsed.exp)
            return true;
        const expiration = new Date(parsed.exp * 1000);
        const secondsTilExpiration = (expiration.valueOf() - Date.now()) / 1000;
        return secondsTilExpiration <= 0;
    }
    catch (error) {
        return true;
    }
};
//# sourceMappingURL=isJwtExpired.js.map